import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import './LoginPage.css';
import '../../assets/styles/form.css';
import showIcon from "../../assets/images/show.svg";
import hideIcon from "../../assets/images/hide.svg";
import LogoHeader from "../../components/LogoHeader";
import { API_BASE_URL } from "../../Variables";
import { connectSocket } from "../../services/Socket";

/**
 * The login page for the application
 * @returns 
 */
function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/home'); // Redirect to home page if logged in
    }
  }, [navigate]);

  const [userData, setUserData] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState('');

  const handleLogin = async(e) => {
    e.preventDefault();

    if(!userData.email) {
      setError('Email is required');
      return;
    }

    if(!userData.password) {
      setError('Password is required');
      return;
    }
    
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, userData);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('user_id', JSON.stringify(response.data.user.id));
      setError('');

      connectSocket(response.data.user.id); // Connect the socket after login

      // Redirect to the appropriate page based on user type
      if(response.data.user.user_type_id === 1) {
        navigate('/dashboard');
      }else {
        navigate('/home');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.message || 'An error occurred');
      } else {
        setError('There was an error logging in: ' + error.message);
      }
    }
  };

  return (
    <div className="login-page">
      <LogoHeader className="signup-logo"/>
      <h2>Login</h2>
      <div className="form-container">
        <form onSubmit={handleLogin}>
          <div className="form-input">
            <label htmlFor="email">Email</label>
            <input 
              id="email"
              type="email" 
              value={userData.email} 
              onChange={(e) => setUserData({ ...userData, email: e.target.value })} 
            />
          </div>
          <div className="form-input">
            <label htmlFor="password">Password</label>
            <div className="password-input">
              <input 
                id="password"
                type={showPassword ? 'text' : 'password'} 
                value={userData.password} 
                onChange={(e) => setUserData({ ...userData, password: e.target.value })} 
              />

              <img src={showPassword ? hideIcon : showIcon} alt="Show password" 
                className="password-visibility" onClick={() => setShowPassword(!showPassword)}/>
              
            </div>
          </div>
          <div className="form-input">
            <button type="submit" className="primary-button">Login</button>
          </div>
        </form>
        {error && <div className="error">{error}</div>}
      </div>
      Don't have an account? <a href="/">Sign up here</a>
    </div>
  );
}

export default LoginPage;
